import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import styled from 'styled-components';
import App from './App';
import './global.css';
import { ReduxProvider } from './redux/provider';
import { persistor } from './redux/store';
import * as serviceWorker from './serviceWorker';

const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;
    min-height: 100vh;
    max-width: 100vw;
    overflow: hidden;
    background-color: #f3f7fe;
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
export const history = createBrowserHistory();

root.render(
    <ReduxProvider>
        <PersistGate loading={null} persistor={persistor}>
            <FlexWrapper>
                <BrowserRouter history={history}>
                    <App />
                </BrowserRouter>
            </FlexWrapper>
        </PersistGate>
    </ReduxProvider>,
);

serviceWorker.unregister();
